
var stateManager = require('../state/stateManager.js');
var stringUtil = require('../string/stringUtil.js');
var uiConstants = require('../domain/uiConstants');

module.exports.getTerminalCode = function()
{
    return stateManager.getStore().getState().terminalCode;
}


module.exports.getTerminalId = function()
{
    return stateManager.getStore().getState().terminal.id;
}

module.exports.getTerminalFloatIdentifier = function()
{
    return stateManager.getStore().getState().terminal.floatIdentifier;
}


module.exports.getTerminalById = function(terminalId)
{
    return stateManager.getStore().getState().terminals.find(t => stringUtil.areStringSame(t.id, terminalId));
}

module.exports.isRunningUnderBrowserShell = function()
{
    return stringUtil.areStringSame(stateManager.getStore().getState().shellType, uiConstants.BrowserShellType);
}

module.exports.isRunningUnderAndroidShell = function()
{
    return stringUtil.areStringSame(stateManager.getStore().getState().shellType, uiConstants.AndroidShellType);
}

module.exports.isRunningUnderWindowsShell = function()
{
    return stringUtil.areStringSame(stateManager.getStore().getState().shellType, uiConstants.WindowsShellType);
}

module.exports.isRunningUnderIOSShell = function()
{
    return stringUtil.areStringSame(stateManager.getStore().getState().shellType, uiConstants.IOSShellType);
}

module.exports.getTerminalIntegrations = function ()
{
    return stateManager.getStore().getState().terminal.integrations || [];
}